import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEO from '@/components/base/SEO';
import AboutSchema from '@/components/base/AboutSchema';
import { testimonials, siteInfo } from '@/mocks/home';

const stats = siteInfo.stats;

const aboutFAQs = [
  {
    question: '51漫画网是什么平台？',
    answer: '51漫画网是一个专注于韩国漫画的中文在线阅读平台，提供无删减、高清画质的韩漫资源。平台支持下拉式流畅阅读，覆盖恋爱、奇幻、动作、剧情、重生等多种题材，致力于为韩漫爱好者打造最优质的阅读体验。自2018年上线以来，已累计服务超过500万忠实用户。',
  },
  {
    question: '为什么选择51漫画网？',
    answer: '第一，无删减内容——我们承诺所有漫画均为完整版本，不对内容做任何修改或删减。第二，下拉式阅读——创新的阅读方式无需翻页，滑动即可连续阅读，极大提升阅读流畅度。第三，更新及时——与韩国更新进度保持同步，追更不等待。第四，资源丰富——超过10,000部韩漫资源，题材多样应有尽有。',
  },
  {
    question: '如何联系我们？',
    answer: '您可以通过页脚的邮箱订阅与我们保持联系，获取最新更新通知。如有商务合作、版权问题或其他事宜，欢迎发送邮件至我们的官方邮箱。我们的团队会在1-3个工作日内回复您的邮件。',
  },
  {
    question: '51漫画网是否需要付费？',
    answer: '51漫画网目前提供完全免费的韩漫阅读服务，所有漫画内容均可免费在线阅读。我们致力于打造免费韩漫大全，让每一位韩漫爱好者都能无障碍地享受优质漫画内容。未来如有任何商业模式调整，我们会提前通知所有用户。',
  },
];

export default function AboutPage() {
  return (
    <>
      <SEO
        title="关于我们-51漫画网 | 免费韩漫大全品牌介绍"
        description="51漫画网自2018年创立，提供无删减韩国漫画下拉式阅读服务，服务超过500万用户，拥有10,000+韩漫资源，致力于打造最优质的免费韩漫阅读平台。"
        keywords="51漫画网,关于我们,韩漫平台,免费韩漫,品牌介绍,联系我们"
        canonical="https://51manhua.com/about"
      />
      <AboutSchema />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <div className="pt-16">
            <Breadcrumb items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]} />
          </div>

          {/* Brand Story */}
          <section className="w-full bg-gradient-to-b from-[#3b2d24] to-[#2a1f18] py-16 md:py-24">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
                <div className="lg:w-3/5">
                  <span className="inline-block px-3 py-1 bg-accent-100/20 text-accent-300 rounded-md text-xs font-medium mb-5">
                    &middot; 关于51漫画网 &middot;
                  </span>
                  <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4">
                    打造最优质的<br />韩漫阅读平台
                  </h1>
                  <p className="text-white/60 text-sm md:text-base leading-relaxed max-w-xl">
                    51漫画网创立于{siteInfo.established}年，是专注于韩国漫画的中文在线阅读平台。我们致力于为全球华语韩漫爱好者提供无删减、高清画质、下拉式流畅阅读的优质体验。经过多年发展，我们已积累了超过10,000部优质韩漫资源，覆盖恋爱、奇幻、动作、剧情等八大题材分类。
                  </p>
                </div>
                <div className="lg:w-2/5 flex items-start gap-6">
                  <div className="w-36 h-36 md:w-44 md:h-44 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20brand%20illustration%2C%20warm%20cozy%20library%20with%20books%2C%20soft%20lighting%2C%20Korean%20digital%20art%20style%2C%20warm%20amber%20and%20cream%20tones%2C%20inviting%20atmosphere&width=400&height=400&seq=about-brand-img&orientation=squarish"
                      alt="51漫画网品牌"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <span className="font-heading text-5xl md:text-7xl font-bold text-white/90 block leading-none">
                      {siteInfo.established}
                    </span>
                    <p className="text-white/50 text-sm mt-2">创立年份</p>
                    <p className="text-white/40 text-xs mt-1">八年专注韩漫阅读</p>
                    <p className="text-white/40 text-xs">免费 · 无删减 · 高清</p>
                    <Link
                      to="/"
                      className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 border border-white/30 hover:border-white/60 text-white rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      开始阅读
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Stats Grid */}
          <section className="w-full bg-background-100 py-14 md:py-20">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-10 md:mb-14">
                <div>
                  <span className="text-xs font-medium text-foreground-500 tracking-widest uppercase mb-2 block">
                    平台数据
                  </span>
                  <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                    值得信赖的韩漫平台
                  </h2>
                  <p className="font-heading text-3xl md:text-4xl font-light italic text-secondary-500 mt-1">
                    数据说明一切
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {stats.map((stat, idx) => {
                  const bgColors = [
                    'bg-gradient-to-br from-rose-300/40 via-rose-200/30 to-rose-100/20',
                    'bg-gradient-to-br from-emerald-300/40 via-emerald-200/30 to-emerald-100/20',
                    'bg-gradient-to-br from-amber-300/40 via-amber-200/30 to-amber-100/20',
                    'bg-gradient-to-br from-stone-300/40 via-stone-200/30 to-stone-100/20',
                  ];
                  return (
                    <div key={idx} className="rounded-lg overflow-hidden">
                      <div className={`relative aspect-[3/4] ${bgColors[idx]} flex flex-col items-center justify-center px-4 text-center`}>
                        <span className="font-heading text-4xl md:text-5xl font-bold text-foreground-900/20 mb-3">
                          {stat.value}
                        </span>
                        <h4 className="font-semibold text-foreground-950 text-sm mb-1">{stat.label}</h4>
                        <p className="text-foreground-500 text-xs">{stat.desc}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>

          {/* Platform Reputation (Testimonials) */}
          <section className="w-full bg-background-50 py-14 md:py-20">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="text-center mb-10 md:mb-14">
                <div className="flex items-center justify-center gap-2 mb-3">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-xs font-medium text-foreground-500 tracking-wide">平台声誉</span>
                </div>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                  万千漫友的信赖
                </h2>
                <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
                  真实用户评价，见证51漫画网的品质与口碑
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {testimonials.map((t, idx) => (
                  <div
                    key={t.id}
                    className={`bg-white rounded-lg p-5 md:p-6 ${idx >= 4 ? 'opacity-70' : ''}`}
                  >
                    <div className="flex items-center gap-0.5 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-sm ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-secondary-300'}`}
                        ></i>
                      ))}
                    </div>
                    <h4 className="font-semibold text-foreground-950 text-sm mb-2">{t.title}</h4>
                    <p className="text-foreground-500 text-xs leading-relaxed mb-4 line-clamp-3">{t.content}</p>
                    <div className="flex items-center gap-3">
                      <img src={t.avatar} alt={t.name} className="w-9 h-9 rounded-full object-cover" />
                      <div>
                        <p className="text-foreground-950 text-sm font-semibold">{t.name}</p>
                        <p className="text-foreground-500 text-xs">{t.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="w-full bg-background-100 py-14 md:py-20">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
                常见问题
              </h2>
              <div className="max-w-3xl mx-auto space-y-3">
                {aboutFAQs.map((faq, idx) => (
                  <details key={idx} className="group bg-white rounded-lg p-5 cursor-pointer">
                    <summary className="flex items-center justify-between text-sm font-semibold text-foreground-950 list-none">
                      {faq.question}
                      <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                      <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                    </summary>
                    <p className="mt-3 text-xs text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* Cooperation CTA */}
          <section className="relative w-full h-[350px] md:h-[420px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20warm%20business%20atmosphere%2C%20creative%20workspace%20with%20art%20supplies%2C%20soft%20golden%20hour%20lighting%2C%20Korean%20digital%20art%20style%2C%20inviting%20professional%20yet%20cozy%20vibe&width=1800&height=900&seq=about-cta-cooperation&orientation=landscape"
              alt="商务合作"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
            <div className="relative z-10 w-full h-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col items-center justify-center text-center">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-white tracking-wide mb-3">
                期待与您合作
              </h2>
              <p className="text-white/65 text-sm md:text-base max-w-md mb-8">
                无论您是内容创作者、广告合作方还是版权方
                <br />欢迎与我们联系，共创韩漫阅读新体验
              </p>
              <Link
                to="/"
                className="group inline-flex items-center gap-3 px-8 py-3.5 bg-foreground-950 hover:bg-foreground-900 text-white rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <span className="w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center">
                  <i className="ri-mail-send-line text-white text-xs"></i>
                </span>
                商务合作
                <i className="ri-arrow-right-up-line transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
              </Link>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}